import { apiConverter } from '@front/repository/Api/converter';
import { getApiClient } from '@front/repository/common/apiClient';
import type { IFileRepository as I } from './interface';

export class FileRepository implements I {
  getUploadUrl: I.GetUploadUrl = async (params, options) => {
    const res = await getApiClient().POST('/files/upload-url', {
      body: {
        projectId: params.projectId,
        fileName: params.fileName,
        fileSize: params.fileSize,
        contentType: params.contentType,
        contentEncoding: params.contentEncoding,
      },
      signal: options?.signal,
    });
    if (!res.data) throw new Error('Failed to get upload URL');
    return res.data;
  };

  analyzeCsv: I.AnalyzeCsv = async (params, options) => {
    const res = await getApiClient().POST('/files/analyze', {
      body: { projectId: params.projectId, fileId: params.fileId },
      signal: options?.signal,
    });
    if (!res.data) throw new Error('Failed to analyze CSV');
    return apiConverter.CsvAnalysis.fromApi(res.data);
  };

  uploadToGcs: I.UploadToGcs = (params) =>
    new Promise<void>((resolve, reject) => {
      const xhr = new XMLHttpRequest();
      xhr.open('PUT', params.uploadUrl);
      xhr.setRequestHeader('Content-Type', params.contentType);

      xhr.upload.onprogress = (e) => {
        if (e.lengthComputable) {
          params.onProgress?.(e.loaded / e.total);
        }
      };
      xhr.onload = () => {
        if (xhr.status >= 200 && xhr.status < 300) {
          params.onProgress?.(1);
          resolve();
        } else {
          reject(new Error(`Failed to upload to storage: ${xhr.status} ${xhr.statusText}`));
        }
      };
      xhr.onerror = () => reject(new Error('Failed to upload to storage: network error'));
      xhr.ontimeout = () => reject(new Error('Failed to upload to storage: timeout'));

      if (params.signal) {
        if (params.signal.aborted) {
          xhr.abort();
          const abortErr = new Error('Upload aborted');
          abortErr.name = 'AbortError';
          reject(abortErr);
          return;
        }
        params.signal.addEventListener('abort', () => {
          xhr.abort();
          const abortErr = new Error('Upload aborted');
          abortErr.name = 'AbortError';
          reject(abortErr);
        });
      }

      xhr.send(params.file);
    });
}
